(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~upload"],{

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _upload__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51);
/* harmony import */ var _dragger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73);
/* harmony import */ var _interface__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UploadProps", function() { return _interface__WEBPACK_IMPORTED_MODULE_2__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UploadListProps", function() { return _interface__WEBPACK_IMPORTED_MODULE_2__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UploadChangeParam", function() { return _interface__WEBPACK_IMPORTED_MODULE_2__["a"]; });


 // 样式文件
// import './style/index.scss';


_upload__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].Dragger = _dragger__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"];

_upload__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].install = function (Vue) {
  Vue.component(_upload__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].name, _upload__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);
  Vue.component(_dragger__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].name, _dragger__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]);
};

/* harmony default export */ __webpack_exports__["default"] = (_upload__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// EXTERNAL MODULE: ./src/utils/props_util.js
var props_util = __webpack_require__(1);

// EXTERNAL MODULE: ./src/utils/BaseMixin.js
var BaseMixin = __webpack_require__(4);

// EXTERNAL MODULE: ./node_modules/lodash/partition.js
var partition = __webpack_require__(215);
var partition_default = /*#__PURE__*/__webpack_require__.n(partition);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// CONCATENATED MODULE: ./src/base/vc-upload/src/request.js
function getError(option, xhr) {
  var msg = "cannot ".concat(option.method, " ").concat(option.action, " ").concat(xhr.status, "'");
  var err = new Error(msg);
  err.status = xhr.status;
  err.method = option.method;
  err.url = option.action;
  return err;
}

function getBody(xhr) {
  var text = xhr.responseText || xhr.response;

  if (!text) {
    return text;
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
} // option {
//  onProgress: (event: { percent: number }): void,
//  onError: (event: Error, body?: Object): void,
//  onSuccess: (body: Object): void,
//  data: Object,
//  filename: String,
//  file: File,
//  withCredentials: Boolean,
//  action: String,
//  headers: Object,
// }


function upload(option) {
  var xhr = new window.XMLHttpRequest();

  if (option.onProgress && xhr.upload) {
    xhr.upload.onprogress = function progress(e) {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100;
      }

      option.onProgress(e);
    };
  }

  var formData = new window.FormData();

  if (option.data) {
    Object.keys(option.data).forEach(function (key) {
      var value = option.data[key]; // support key-value array data

      if (Array.isArray(value)) {
        value.forEach(function (item) {
          // { list: [ 11, 22 ] }
          // formData.append('list[]', 11);
          formData.append("".concat(key, "[]"), item);
        });
        return;
      }

      formData.append(key, option.data[key]);
    });
  }

  formData.append(option.filename, option.file);

  xhr.onerror = function error(e) {
    option.onError(e);
  };

  xhr.onload = function onload() {
    // allow success when 2xx status
    // see https://github.com/react-component/upload/issues/34
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(option, xhr), getBody(xhr));
    }

    option.onSuccess(getBody(xhr), xhr);
  };

  xhr.open(option.method, option.action, true); // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179

  if (option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true;
  }

  var headers = option.headers || {}; // when set headers['X-Requested-With'] = null , can close default XHR header
  // see https://github.com/react-component/upload/issues/33

  if (headers['X-Requested-With'] !== null) {
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  }

  for (var h in headers) {
    if (headers.hasOwnProperty(h) && headers[h] !== null) {
      xhr.setRequestHeader(h, headers[h]);
    }
  }

  xhr.send(formData);
  return {
    abort: function abort() {
      xhr.abort();
    }
  };
}
// CONCATENATED MODULE: ./src/base/vc-upload/src/uid.js
var now = +new Date();
var index = 0;
function uid_uid() {
  return "vc-upload-".concat(now, "-").concat(++index);
}
// CONCATENATED MODULE: ./src/base/vc-upload/src/attr-accept.js
function endsWith(str, suffix) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

/* harmony default export */ var attr_accept = (function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = file.type || '';
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim();

      if (validType.charAt(0) === '.') {
        return endsWith(fileName.toLowerCase(), validType.toLowerCase());
      } else if (/\/\*$/.test(validType)) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
});
// CONCATENATED MODULE: ./src/base/vc-upload/src/traverseFileTree.js
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function loopFiles(item, callback) {
  var dirReader = item.createReader();
  var fileList = [];

  function sequence() {
    dirReader.readEntries(function (entries) {
      var entryList = Array.prototype.slice.apply(entries);
      fileList = fileList.concat(entryList); // Check if all the file has been viewed

      var isFinished = !entryList.length;

      if (isFinished) {
        callback(fileList);
      } else {
        sequence();
      }
    });
  }

  sequence();
}

var traverseFileTree = function traverseFileTree(files, callback, isAccepted) {
  var _traverseFileTree = function _traverseFileTree(item, path) {
    path = path || '';

    if (item.isFile) {
      item.file(function (file) {
        if (isAccepted(file)) {
          // https://github.com/ant-design/ant-design/issues/16426
          if (item.fullPath && !file.webkitRelativePath) {
            Object.defineProperties(file, {
              webkitRelativePath: {
                writable: true
              }
            });
            file.webkitRelativePath = item.fullPath.replace(/^\//, '');
            Object.defineProperties(file, {
              webkitRelativePath: {
                writable: false
              }
            });
          }

          callback([file]);
        }
      });
    } else if (item.isDirectory) {
      loopFiles(item, function (entries) {
        entries.forEach(function (entryItem) {
          _traverseFileTree(entryItem, "".concat(path).concat(item.name, "/"));
        });
      });
    }
  };

  var _iterator = _createForOfIteratorHelper(files),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var file = _step.value;

      _traverseFileTree(file.webkitGetAsEntry());
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

/* harmony default export */ var src_traverseFileTree = (traverseFileTree);
// CONCATENATED MODULE: ./src/base/vc-upload/src/AjaxUploader.jsx
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var upLoadPropTypes = {
  componentTag: vue_types["a" /* default */].string,
  // style: PropTypes.object,
  prefixCls: vue_types["a" /* default */].string,
  name: vue_types["a" /* default */].string,
  // className: PropTypes.string,
  multiple: vue_types["a" /* default */].bool,
  directory: vue_types["a" /* default */].bool,
  disabled: vue_types["a" /* default */].bool,
  accept: vue_types["a" /* default */].string,
  // children: PropTypes.any,
  // onStart: PropTypes.func,
  data: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].object, vue_types["a" /* default */].func]),
  action: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].func]),
  headers: vue_types["a" /* default */].object,
  beforeUpload: vue_types["a" /* default */].func,
  customRequest: vue_types["a" /* default */].func,
  // onProgress: PropTypes.func,
  withCredentials: vue_types["a" /* default */].bool,
  openFileDialogOnClick: vue_types["a" /* default */].bool,
  transformFile: vue_types["a" /* default */].func,
  method: vue_types["a" /* default */].string
};
var AjaxUploader = {
  inheritAttrs: false,
  name: 'ajaxUploader',
  mixins: [BaseMixin["a" /* default */]],
  props: upLoadPropTypes,
  data: function data() {
    this.reqs = {};
    return {
      uid: uid_uid()
    };
  },
  mounted: function mounted() {
    this._isMounted = true;
  },
  beforeDestroy: function beforeDestroy() {
    this._isMounted = false;
    this.abort();
  },
  methods: {
    onChange: function onChange(e) {
      var files = e.target.files;
      this.uploadFiles(files);
      this.reset();
    },
    onClick: function onClick() {
      var el = this.$refs.fileInputRef;

      if (!el) {
        return;
      }

      el.click();
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        this.onClick();
      }
    },
    onFileDrop: function onFileDrop(e) {
      var _this = this;

      var multiple = this.$props.multiple;
      e.preventDefault();

      if (e.type === 'dragover') {
        return;
      }

      if (this.directory) {
        src_traverseFileTree(e.dataTransfer.items, this.uploadFiles, function (_file) {
          return attr_accept(_file, _this.accept);
        });
      } else {
        var files = partition_default()(Array.prototype.slice.call(e.dataTransfer.files), function (file) {
          return attr_accept(file, _this.accept);
        });
        var successFiles = files[0];
        var errorFiles = files[1];

        if (multiple === false) {
          successFiles = successFiles.slice(0, 1);
        }

        this.uploadFiles(successFiles);

        if (errorFiles.length) {
          this.$emit('reject', errorFiles);
        }
      }
    },
    uploadFiles: function uploadFiles(files) {
      var _this2 = this;

      var postFiles = Array.prototype.slice.call(files);
      postFiles.map(function (file) {
        file.uid = uid_uid();
        return file;
      }).forEach(function (file) {
        _this2.upload(file, postFiles);
      });
    },
    upload: function upload(file, fileList) {
      var _this3 = this;

      if (!this.beforeUpload) {
        // always async in case use react state to keep fileList
        return setTimeout(function () {
          return _this3.post(file);
        }, 0);
      }

      var before = this.beforeUpload(file, fileList);

      if (before && before.then) {
        before.then(function (processedFile) {
          var processedFileType = Object.prototype.toString.call(processedFile);

          if (processedFileType === '[object File]' || processedFileType === '[object Blob]') {
            return _this3.post(processedFile);
          }

          return _this3.post(file);
        }).catch(function (e) {
          console && console.log(e); // eslint-disable-line
        });
      } else if (before !== false) {
        setTimeout(function () {
          return _this3.post(file);
        }, 0);
      }
    },
    post: function post(file) {
      var _this4 = this;

      if (!this._isMounted) {
        return;
      }

      var props = this.$props;
      var data = props.data;
      var _props$transformFile = props.transformFile,
          transformFile = _props$transformFile === void 0 ? function (originFile) {
        return originFile;
      } : _props$transformFile;
      new Promise(function (resolve) {
        var action = _this4.action;

        if (typeof action === 'function') {
          return resolve(action(file));
        }

        resolve(action);
      }).then(function (action) {
        var uid = file.uid;
        var request = _this4.customRequest || upload;
        var transform = Promise.resolve(transformFile(file)).catch(function (e) {
          console.error(e); // eslint-disable-line no-console
        });
        transform.then(function (transformedFile) {
          if (typeof data === 'function') {
            data = data(file);
          }

          var requestOption = {
            action: action,
            filename: _this4.name,
            data: data,
            file: transformedFile,
            headers: _this4.headers,
            withCredentials: _this4.withCredentials,
            method: props.method || 'post',
            onProgress: function onProgress(e) {
              _this4.$emit('progress', e, file);
            },
            onSuccess: function onSuccess(ret, xhr) {
              delete _this4.reqs[uid];

              _this4.$emit('success', ret, file, xhr);
            },
            onError: function onError(err, ret) {
              delete _this4.reqs[uid];

              _this4.$emit('error', err, ret, file);
            }
          };
          _this4.reqs[uid] = request(requestOption);

          _this4.$emit('start', file);
        });
      });
    },
    reset: function reset() {
      this.setState({
        uid: uid_uid()
      });
    },
    abort: function abort(file) {
      var reqs = this.reqs;

      if (file) {
        var uid = file;

        if (file && file.uid) {
          uid = file.uid;
        }

        if (reqs[uid] && reqs[uid].abort) {
          reqs[uid].abort();
        }

        delete reqs[uid];
      } else {
        Object.keys(reqs).forEach(function (uid) {
          if (reqs[uid] && reqs[uid].abort) {
            reqs[uid].abort();
          }

          delete reqs[uid];
        });
      }
    }
  },
  render: function render() {
    var _classNames;

    var h = arguments[0];
    var $props = this.$props,
        $attrs = this.$attrs;
    var Tag = $props.componentTag,
        prefixCls = $props.prefixCls,
        disabled = $props.disabled,
        multiple = $props.multiple,
        accept = $props.accept,
        directory = $props.directory,
        openFileDialogOnClick = $props.openFileDialogOnClick;
    var cls = external_classnames_default()((_classNames = {}, _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
    var events = disabled ? {} : {
      click: openFileDialogOnClick ? this.onClick : function () {},
      keydown: openFileDialogOnClick ? this.onKeyDown : function () {},
      drop: this.onFileDrop,
      dragover: this.onFileDrop
    };
    var tagProps = {
      on: _objectSpread(_objectSpread({}, Object(props_util["getListeners"])(this)), events),
      attrs: {
        role: 'button',
        tabIndex: disabled ? null : '0'
      },
      class: cls
    };
    return h(Tag, tagProps, [h("input", {
      attrs: {
        id: $attrs.id,
        type: "file",
        accept: accept,
        directory: directory ? 'directory' : null,
        webkitdirectory: directory ? 'webkitdirectory' : null,
        multiple: multiple
      },
      ref: "fileInputRef",
      on: {
        "click": function click(e) {
          return e.stopPropagation();
        },
        "change": this.onChange
      },
      // https://github.com/ant-design/ant-design/issues/19948
      key: this.uid,
      style: {
        display: 'none'
      }
    }), this.$slots.default]);
  }
};
/* harmony default export */ var src_AjaxUploader = (AjaxUploader);
// EXTERNAL MODULE: ./src/utils/warning.js + 1 modules
var warning = __webpack_require__(12);

// CONCATENATED MODULE: ./src/base/vc-upload/src/IframeUploader.jsx
function IframeUploader_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function IframeUploader_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { IframeUploader_ownKeys(Object(source), true).forEach(function (key) { IframeUploader_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { IframeUploader_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function IframeUploader_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var IFRAME_STYLE = {
  position: 'absolute',
  top: 0,
  opacity: 0,
  filter: 'alpha(opacity=0)',
  left: 0,
  zIndex: 9999
}; // diferent from AjaxUpload, can only upload on at one time, serial seriously

var IframeUploader = {
  mixins: [BaseMixin["a" /* default */]],
  props: {
    componentTag: vue_types["a" /* default */].string,
    // style: PropTypes.object,
    disabled: vue_types["a" /* default */].bool,
    prefixCls: vue_types["a" /* default */].string,
    // className: PropTypes.string,
    accept: vue_types["a" /* default */].string,
    // onStart: PropTypes.func,
    multiple: vue_types["a" /* default */].bool,
    // children: PropTypes.any,
    data: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].object, vue_types["a" /* default */].func]),
    action: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].func]),
    name: vue_types["a" /* default */].string
  },
  data: function data() {
    this.file = {};
    return {
      uploading: false
    };
  },
  methods: {
    onLoad: function onLoad() {
      if (!this.uploading) {
        return;
      }

      var file = this.file;
      var response;

      try {
        var doc = this.getIframeDocument();
        var script = doc.getElementsByTagName('script')[0];

        if (script && script.parentNode === doc.body) {
          doc.body.removeChild(script);
        }

        response = doc.body.innerHTML;
        this.$emit('success', response, file);
      } catch (err) {
        Object(warning["a" /* default */])(false, 'cross domain error for Upload. Maybe server should return document.domain script. see Note from https://github.com/react-component/upload');
        response = 'cross-domain';
        this.$emit('error', err, null, file);
      }

      this.endUpload();
    },
    onChange: function onChange() {
      var _this = this;

      var target = this.getFormInputNode(); // ie8/9 don't support FileList Object
      // http://stackoverflow.com/questions/12830058/ie8-input-type-file-get-files

      var file = this.file = {
        uid: uid_uid(),
        name: target.value && target.value.substring(target.value.lastIndexOf('\\') + 1, target.value.length)
      };
      this.startUpload();
      var props = this.$props;

      if (!props.beforeUpload) {
        return this.post(file);
      }

      var before = props.beforeUpload(file);

      if (before && before.then) {
        before.then(function () {
          _this.post(file);
        }, function () {
          _this.endUpload();
        });
      } else if (before !== false) {
        this.post(file);
      } else {
        this.endUpload();
      }
    },
    getIframeNode: function getIframeNode() {
      return this.$refs.iframeRef;
    },
    getIframeDocument: function getIframeDocument() {
      return this.getIframeNode().contentDocument;
    },
    getFormNode: function getFormNode() {
      return this.getIframeDocument().getElementById('form');
    },
    getFormInputNode: function getFormInputNode() {
      return this.getIframeDocument().getElementById('input');
    },
    getFormDataNode: function getFormDataNode() {
      return this.getIframeDocument().getElementById('data');
    },
    getFileForMultiple: function getFileForMultiple(file) {
      return this.multiple ? [file] : file;
    },
    getIframeHTML: function getIframeHTML(domain) {
      var domainScript = '';
      var domainInput = '';

      if (domain) {
        var script = 'script';
        domainScript = "<".concat(script, ">document.domain=\"").concat(domain, "\";</").concat(script, ">");
        domainInput = "<input name=\"_documentDomain\" value=\"".concat(domain, "\" />");
      }

      return "\n      <!DOCTYPE html>\n      <html>\n      <head>\n      <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\" />\n      <style>\n      body,html {padding:0;margin:0;border:0;overflow:hidden;}\n      </style>\n      ".concat(domainScript, "\n      </head>\n      <body>\n      <form method=\"post\"\n      encType=\"multipart/form-data\"\n      action=\"\" id=\"form\"\n      style=\"display:block;height:9999px;position:relative;overflow:hidden;\">\n      <input id=\"input\" type=\"file\"\n       name=\"").concat(this.name, "\"\n       style=\"position:absolute;top:0;right:0;height:9999px;font-size:9999px;cursor:pointer;\"/>\n      ").concat(domainInput, "\n      <span id=\"data\"></span>\n      </form>\n      </body>\n      </html>\n      ");
    },
    initIframeSrc: function initIframeSrc() {
      if (this.domain) {
        this.getIframeNode().src = "javascript:void((function(){\n          var d = document;\n          d.open();\n          d.domain='".concat(this.domain, "';\n          d.write('');\n          d.close();\n        })())");
      }
    },
    initIframe: function initIframe() {
      var iframeNode = this.getIframeNode();
      var win = iframeNode.contentWindow;
      var doc;
      this.domain = this.domain || '';
      this.initIframeSrc();

      try {
        doc = win.document;
      } catch (e) {
        this.domain = document.domain;
        this.initIframeSrc();
        win = iframeNode.contentWindow;
        doc = win.document;
      }

      doc.open('text/html', 'replace');
      doc.write(this.getIframeHTML(this.domain));
      doc.close();
      this.getFormInputNode().onchange = this.onChange;
    },
    endUpload: function endUpload() {
      if (this.uploading) {
        this.file = {}; // hack avoid batch

        this.uploading = false;
        this.setState({
          uploading: false
        });
        this.initIframe();
      }
    },
    startUpload: function startUpload() {
      if (!this.uploading) {
        this.uploading = true;
        this.setState({
          uploading: true
        });
      }
    },
    updateIframeWH: function updateIframeWH() {
      var rootNode = this.$el;
      var iframeNode = this.getIframeNode();
      iframeNode.style.height = "".concat(rootNode.offsetHeight, "px");
      iframeNode.style.width = "".concat(rootNode.offsetWidth, "px");
    },
    abort: function abort(file) {
      if (file) {
        var uid = file;

        if (file && file.uid) {
          uid = file.uid;
        }

        if (uid === this.file.uid) {
          this.endUpload();
        }
      } else {
        this.endUpload();
      }
    },
    post: function post(file) {
      var _this2 = this;

      var formNode = this.getFormNode();
      var dataSpan = this.getFormDataNode();
      var data = this.$props.data;

      if (typeof data === 'function') {
        data = data(file);
      }

      var inputs = document.createDocumentFragment();

      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          var input = document.createElement('input');
          input.setAttribute('name', key);
          input.value = data[key];
          inputs.appendChild(input);
        }
      }

      dataSpan.appendChild(inputs);
      new Promise(function (resolve) {
        var action = _this2.action;

        if (typeof action === 'function') {
          return resolve(action(file));
        }

        resolve(action);
      }).then(function (action) {
        formNode.setAttribute('action', action);
        formNode.submit();
        dataSpan.innerHTML = '';

        _this2.$emit('start', file);
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      _this3.updateIframeWH();

      _this3.initIframe();
    });
  },
  updated: function updated() {
    var _this4 = this;

    this.$nextTick(function () {
      _this4.updateIframeWH();
    });
  },
  render: function render() {
    var _classNames;

    var h = arguments[0];
    var _this$$props = this.$props,
        Tag = _this$$props.componentTag,
        disabled = _this$$props.disabled,
        prefixCls = _this$$props.prefixCls;

    var iframeStyle = IframeUploader_objectSpread(IframeUploader_objectSpread({}, IFRAME_STYLE), {}, {
      display: this.uploading || disabled ? 'none' : ''
    });

    var cls = external_classnames_default()((_classNames = {}, IframeUploader_defineProperty(_classNames, prefixCls, true), IframeUploader_defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
    return h(Tag, {
      attrs: {
        className: cls
      },
      style: {
        position: 'relative',
        zIndex: 0
      }
    }, [h("iframe", {
      ref: "iframeRef",
      on: {
        "load": this.onLoad
      },
      style: iframeStyle
    }), this.$slots.default]);
  }
};
/* harmony default export */ var src_IframeUploader = (IframeUploader);
// CONCATENATED MODULE: ./src/base/vc-upload/src/Upload.jsx
function Upload_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Upload_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Upload_ownKeys(Object(source), true).forEach(function (key) { Upload_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Upload_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Upload_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







function empty() {}

var uploadProps = {
  componentTag: vue_types["a" /* default */].string,
  prefixCls: vue_types["a" /* default */].string,
  action: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].func]),
  name: vue_types["a" /* default */].string,
  multipart: vue_types["a" /* default */].bool,
  directory: vue_types["a" /* default */].bool,
  // onError: PropTypes.func,
  // onSuccess: PropTypes.func,
  // onProgress: PropTypes.func,
  // onStart: PropTypes.func,
  data: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].object, vue_types["a" /* default */].func]),
  headers: vue_types["a" /* default */].object,
  accept: vue_types["a" /* default */].string,
  multiple: vue_types["a" /* default */].bool,
  disabled: vue_types["a" /* default */].bool,
  beforeUpload: vue_types["a" /* default */].func,
  customRequest: vue_types["a" /* default */].func,
  // onReady: PropTypes.func,
  withCredentials: vue_types["a" /* default */].bool,
  supportServerRender: vue_types["a" /* default */].bool,
  openFileDialogOnClick: vue_types["a" /* default */].bool,
  method: vue_types["a" /* default */].string
};
/* harmony default export */ var Upload = ({
  name: 'Upload',
  mixins: [BaseMixin["a" /* default */]],
  inheritAttrs: false,
  props: Object(props_util["initDefaultProps"])(uploadProps, {
    componentTag: 'span',
    prefixCls: 'rc-upload',
    data: {},
    headers: {},
    name: 'file',
    multipart: false,
    // onReady: empty,
    // onStart: empty,
    // onError: empty,
    // onSuccess: empty,
    supportServerRender: false,
    multiple: false,
    beforeUpload: empty,
    withCredentials: false,
    openFileDialogOnClick: true
  }),
  data: function data() {
    return {
      Component: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      if (_this.supportServerRender) {
        _this.setState({
          Component: _this.getComponent()
        }, function () {
          _this.$emit('ready');
        });
      }
    });
  },
  methods: {
    getComponent: function getComponent() {
      return typeof File !== 'undefined' ? src_AjaxUploader : src_IframeUploader;
    },
    abort: function abort(file) {
      this.$refs.uploaderRef.abort(file);
    }
  },
  render: function render() {
    var h = arguments[0];
    var componentProps = {
      props: Upload_objectSpread({}, this.$props),
      on: Object(props_util["getListeners"])(this),
      ref: 'uploaderRef',
      attrs: this.$attrs
    };

    if (this.supportServerRender) {
      var _ComponentUploader = this.Component;

      if (_ComponentUploader) {
        return h(_ComponentUploader, componentProps, [this.$slots.default]);
      }

      return null;
    }

    var ComponentUploader = this.getComponent();
    return h(ComponentUploader, componentProps, [this.$slots.default]);
  }
});
// CONCATENATED MODULE: ./src/base/vc-upload/src/index.js
// export this package's api

/* harmony default export */ var src = (Upload);
// CONCATENATED MODULE: ./src/base/vc-upload/index.js
// rc-upload 2.9.4

/* harmony default export */ var vc_upload = __webpack_exports__["a"] = (src);

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var babel_helper_vue_jsx_merge_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var babel_helper_vue_jsx_merge_props__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_BaseMixin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var utils_props_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);
/* harmony import */ var utils_getTransitionProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22);
/* harmony import */ var base_config_provider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28);
/* harmony import */ var _progress__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _interface__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MegUploadList',
  mixins: [utils_BaseMixin__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]],
  props: Object(utils_props_util__WEBPACK_IMPORTED_MODULE_2__["initDefaultProps"])(_interface__WEBPACK_IMPORTED_MODULE_8__[/* UploadListProps */ "b"], {
    listType: 'text',
    // or picture
    progressAttr: {
      strokeWidth: 2,
      showInfo: false
    },
    showRemoveIcon: true,
    showDownloadIcon: false,
    // showPreviewIcon: true,
    previewFile: _utils__WEBPACK_IMPORTED_MODULE_5__[/* previewImage */ "h"]
  }),
  inject: {
    configProvider: {
      default: function _default() {
        return base_config_provider__WEBPACK_IMPORTED_MODULE_4__["ConfigConsumerProps"];
      }
    }
  },
  updated: function updated() {
    var _this = this;

    this.$nextTick(function () {
      var _this$$props = _this.$props,
          listType = _this$$props.listType,
          items = _this$$props.items,
          previewFile = _this$$props.previewFile;

      if (listType !== 'picture' && listType !== 'picture-card') {
        return;
      }

      (items || []).forEach(function (file) {
        if (typeof document === 'undefined' || typeof window === 'undefined' || !window.FileReader || !window.File || !(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== undefined) {
          return;
        }
        /*eslint-disable */


        file.thumbUrl = '';

        if (previewFile) {
          previewFile(file.originFileObj).then(function (previewDataUrl) {
            // Need append '' to avoid dead loop
            file.thumbUrl = previewDataUrl || '';

            _this.$forceUpdate();
          });
        }
      });
    });
  },
  methods: {
    handlePreview: function handlePreview(file, e) {
      var _getListeners = Object(utils_props_util__WEBPACK_IMPORTED_MODULE_2__["getListeners"])(this),
          preview = _getListeners.preview;

      if (!preview) {
        return;
      }

      e.preventDefault();
      return this.$emit('preview', file);
    },
    // handleDownload(file) { // 下载文件，暂时没用到
    //   const { download } = getListeners(this);
    //   if (typeof download === 'function') {
    //     download(file);
    //   } else if (file.url) {
    //     window.open(file.url);
    //   }
    // },
    handleClose: function handleClose(file) {
      this.$emit('remove', file);
    }
  },
  render: function render() {
    var _this2 = this,
        _classNames4;

    var h = arguments[0];

    var _getOptionProps = Object(utils_props_util__WEBPACK_IMPORTED_MODULE_2__["getOptionProps"])(this),
        customizePrefixCls = _getOptionProps.prefixCls,
        _getOptionProps$items = _getOptionProps.items,
        items = _getOptionProps$items === void 0 ? [] : _getOptionProps$items,
        listType = _getOptionProps.listType,
        showRemoveIcon = _getOptionProps.showRemoveIcon,
        progressAttr = _getOptionProps.progressAttr;

    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls('upload', customizePrefixCls);
    var list = items.map(function (file) {
      var _classNames, _classNames2;

      var progress;
      var fileType = Object(_utils__WEBPACK_IMPORTED_MODULE_5__[/* getFiletye */ "f"])(file.name);
      var icon = h("meg-icon", {
        attrs: {
          original: true,
          name: _utils__WEBPACK_IMPORTED_MODULE_5__[/* IconConfig */ "a"][fileType]
        }
      });

      if (listType === 'picture' || listType === 'picture-card') {
        if (listType === 'picture-card' && file.status === 'uploading') {
          icon = h("div", {
            "class": "".concat(prefixCls, "-list-item-uploading-text")
          }, ["\u6587\u4EF6\u4E0A\u4F20\u4E2D"]);
        } else if (listType === 'picture-card' && !file.thumbUrl && !file.url) {
          icon = h("meg-icon", {
            attrs: {
              original: true,
              name: "megui-pic",
              width: "24px",
              height: "24px",
              color: "#E53635"
            },
            "class": "".concat(prefixCls, "-list-item-thumbnail")
          });
        } else {
          var thumbnail = Object(_utils__WEBPACK_IMPORTED_MODULE_5__[/* isImageUrl */ "g"])(file) ? h("img", {
            attrs: {
              src: file.thumbUrl || file.url,
              alt: file.name
            },
            "class": "".concat(prefixCls, "-list-item-image")
          }) : h("meg-icon", {
            attrs: {
              original: true,
              name: "txt",
              theme: "twoTone"
            },
            "class": "".concat(prefixCls, "-list-item-icon")
          });
          icon = h("a", {
            "class": "".concat(prefixCls, "-list-item-thumbnail"),
            on: {
              "click": function click(e) {
                return _this2.handlePreview(file, e);
              }
            },
            attrs: {
              href: file.url || file.thumbUrl,
              target: "_blank",
              rel: "noopener noreferrer"
            }
          }, [thumbnail]);
        }
      }

      if (file.status === 'uploading') {
        // 上传中的进度条样式
        var progressProps = {
          props: _objectSpread(_objectSpread({}, progressAttr), {}, {
            type: 'line',
            percent: file.percent,
            strokeWidth: 2,
            strokeColor: '#11BD79',
            showInfo: false
          })
        }; // show loading icon if upload progress listener is disabled

        var loadingProgress = 'percent' in file ? h(_progress__WEBPACK_IMPORTED_MODULE_6__["default"], progressProps) : null;
        progress = h("div", {
          "class": "".concat(prefixCls, "-list-item-progress"),
          key: "progress"
        }, [loadingProgress]);
      }

      var infoUploadingClass = classnames__WEBPACK_IMPORTED_MODULE_7___default()((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-list-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-list-item-").concat(file.status || 'done'), true), _defineProperty(_classNames, "".concat(prefixCls, "-list-item-list-type-").concat(listType), true), _classNames));
      var linkProps = typeof file.linkProps === 'string' ? JSON.parse(file.linkProps) : file.linkProps;
      var removeIcon = showRemoveIcon ? h("meg-icon", {
        attrs: {
          original: true,
          name: "megui-fill-close-circle",
          color: listType === 'picture-card' ? '#fff' : file.status === 'error' ? '#E53635' : ''
        },
        on: {
          "click": function click() {
            return _this2.handleClose(file);
          }
        }
      }) : null;
      var downloadIcon = file.status === 'done' ? h("meg-icon", {
        attrs: {
          original: true,
          name: 'megui-fill-check-circle',
          color: "#11BD79" // onClick={() => this.handleDownload(file)}

        }
      }) : null;
      var downloadOrDelete = listType !== 'picture-card' && h("span", {
        key: "download-delete",
        "class": "".concat(prefixCls, "-list-item-card-actions ").concat(listType === 'picture' ? 'picture' : '')
      }, [downloadIcon && h("a", {
        "class": "done-file"
      }, [downloadIcon]), file.status === 'error' && h("span", {
        "class": "error-remind-info"
      }, ["\u4E0A\u4F20\u5931\u8D25"]), removeIcon && h("a", {
        "class": "close-file"
      }, [removeIcon])]);
      var listItemNameClass = classnames__WEBPACK_IMPORTED_MODULE_7___default()((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-list-item-original"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-list-item-original-icon-count-").concat([downloadIcon, removeIcon].filter(function (x) {
        return x;
      }).length), true), _classNames2));
      var preview = file.url ? [h("a", babel_helper_vue_jsx_merge_props__WEBPACK_IMPORTED_MODULE_0___default()([{
        attrs: {
          target: "_blank",
          rel: "noopener noreferrer",
          title: file.name
        },
        "class": listItemNameClass
      }, linkProps, {
        attrs: {
          href: file.url
        },
        on: {
          "click": function click(e) {
            return _this2.handlePreview(file, e);
          }
        }
      }]), [file.name]), downloadOrDelete] : [h("div", {
        key: "view",
        "class": "".concat(prefixCls, "-list-item-original"),
        on: {
          "click": function click(e) {
            return _this2.handlePreview(file, e);
          }
        },
        attrs: {
          title: file.name
        }
      }, [h("div", {
        "class": "".concat(prefixCls, "-list-item-name")
      }, [file.name]), listType === 'picture' && h("div", {
        "class": "".concat(prefixCls, "-list-item-size")
      }, [(file.size / Math.pow(1024, 2)).toFixed(2) + "M"])]), downloadOrDelete];
      var style = file.url || file.thumbUrl ? undefined : {
        pointerEvents: 'none',
        opacity: 0.5
      }; // const previewIcon = showPreviewIcon ? (
      //   <a
      //     href={file.url || file.thumbUrl}
      //     target="_blank"
      //     rel="noopener noreferrer"
      //     style={style}
      //     onClick={e => this.handlePreview(file, e)}
      //   >
      //     <meg-icon original name="eye-o" />
      //   </a>
      // ) : null;

      var actions = listType === 'picture-card' && file.status !== 'uploading' && h("span", {
        "class": "".concat(prefixCls, "-list-item-actions")
      }, [removeIcon]); // let message;
      // if (file.response && typeof file.response === 'string') {
      //   message = file.response;
      // } else {
      //   message = (file.error && file.error.statusText) || locale.uploadError;
      // }

      var transitionProps = Object(utils_getTransitionProps__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])('fade');
      var dom = h("div", {
        "class": infoUploadingClass,
        key: file.uid
      }, [h("div", {
        "class": "".concat(prefixCls, "-list-item-info")
      }, [icon, preview]), actions, h("transition", transitionProps, [progress])]);
      var listContainerNameClass = classnames__WEBPACK_IMPORTED_MODULE_7___default()(_defineProperty({}, "".concat(prefixCls, "-list-picture-card-container"), listType === 'picture-card'));
      return h("div", {
        key: file.uid,
        "class": listContainerNameClass
      }, [dom]);
    });
    var listClassNames = classnames__WEBPACK_IMPORTED_MODULE_7___default()((_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-list"), true), _defineProperty(_classNames4, "".concat(prefixCls, "-list-").concat(listType), true), _classNames4));
    var animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate';
    var transitionGroupProps = Object(utils_getTransitionProps__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])("".concat(prefixCls, "-").concat(animationDirection));
    return h("transition-group", babel_helper_vue_jsx_merge_props__WEBPACK_IMPORTED_MODULE_0___default()([transitionGroupProps, {
      attrs: {
        tag: "div"
      },
      "class": listClassNames
    }]), [list]);
  }
});

/***/ }),

/***/ 28:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return T; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fileToObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return genPercentAdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFileItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return removeFileItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isImageUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return previewImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFiletye; });
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function T() {
  return true;
} // Fix IE file.status problem
// via coping a new Object

function fileToObject(file) {
  return _objectSpread(_objectSpread({}, file), {}, {
    lastModified: file.lastModified,
    lastModifiedDate: file.lastModifiedDate,
    name: file.name,
    size: file.size,
    type: file.type,
    uid: file.uid,
    percent: 0,
    originFileObj: file
  });
}
/**
 * 生成Progress percent: 0.1 -> 0.98
 *   - for ie
 */

function genPercentAdd() {
  var k = 0.1;
  var i = 0.01;
  var end = 0.98;
  return function (s) {
    var start = s;

    if (start >= end) {
      return start;
    }

    start += k;
    k = k - i;

    if (k < 0.001) {
      k = 0.001;
    }

    return start;
  };
}
function getFileItem(file, fileList) {
  var matchKey = file.uid !== undefined ? 'uid' : 'name';
  return fileList.filter(function (item) {
    return item[matchKey] === file[matchKey];
  })[0];
}
function removeFileItem(file, fileList) {
  var matchKey = file.uid !== undefined ? 'uid' : 'name';
  var removed = fileList.filter(function (item) {
    return item[matchKey] !== file[matchKey];
  });

  if (removed.length === fileList.length) {
    return null;
  }

  return removed;
} // ==================== Default Image Preview ====================

var extname = function extname() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var temp = url.split('/');
  var filename = temp[temp.length - 1];
  var filenameWithoutSuffix = filename.split(/#|\?/)[0];
  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [''])[0];
};

var isImageFileType = function isImageFileType(type) {
  return !!type && type.indexOf('image/') === 0;
};

var isImageUrl = function isImageUrl(file) {
  if (isImageFileType(file.type)) {
    return true;
  }

  var url = file.thumbUrl || file.url;
  var extension = extname(url);

  if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i.test(extension)) {
    return true;
  }

  if (/^data:/.test(url)) {
    // other file types of base64
    return false;
  }

  if (extension) {
    // other file types which have extension
    return false;
  }

  return false;
};
var MEASURE_SIZE = 200;
function previewImage(file) {
  return new Promise(function (resolve) {
    if (!isImageFileType(file.type)) {
      resolve('');
      return;
    }

    var canvas = document.createElement('canvas');
    canvas.width = MEASURE_SIZE;
    canvas.height = MEASURE_SIZE;
    canvas.style.cssText = "position: fixed; left: 0; top: 0; width: ".concat(MEASURE_SIZE, "px; height: ").concat(MEASURE_SIZE, "px; z-index: 9999; display: none;");
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var img = new Image();

    img.onload = function () {
      var width = img.width,
          height = img.height;
      var drawWidth = MEASURE_SIZE;
      var drawHeight = MEASURE_SIZE;
      var offsetX = 0;
      var offsetY = 0;

      if (width < height) {
        drawHeight = height * (MEASURE_SIZE / width);
        offsetY = -(drawHeight - drawWidth) / 2;
      } else {
        drawWidth = width * (MEASURE_SIZE / height);
        offsetX = -(drawWidth - drawHeight) / 2;
      }

      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
      var dataURL = canvas.toDataURL();
      document.body.removeChild(canvas);
      resolve(dataURL);
    };

    img.src = window.URL.createObjectURL(file);
  });
}
var IconConfig = {
  'imageType': 'megui-pic',
  'docType': 'doc',
  'folderType': 'folder',
  'pdfType': 'pdf',
  'pptType': 'ppt',
  'txtType': 'txt'
};
function getFiletye(name) {
  if (/\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(name)) {
    return 'imageType';
  }

  if (/\.(doc|docx)$/.test(name)) {
    return 'docType';
  }

  if (/\.(rar|zip|tgz)$/.test(name)) {
    return 'folderType';
  }

  if (/\.(pdf)$/.test(name)) {
    return 'pdfType';
  }

  if (/\.(ppt|pptx)$/.test(name)) {
    return 'pptType';
  }

  return 'txtType';
}

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UploadFileStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UploadChangeParam; });
/* unused harmony export ShowUploadListInterface */
/* unused harmony export UploadLocale */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UploadProps; });
/* unused harmony export UploadState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UploadListProps; });
/* harmony import */ var utils_vue_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


var UploadFileStatus = utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOf(['error', 'success', 'done', 'uploading', 'removed']); // export const HttpRequestHeader {
//   [key: string]: string;
// }
// export const UploadFile = PropsTypes.shape({
//   uid: PropsTypes.oneOfType([
//     PropsTypes.string,
//     PropsTypes.number,
//   ]),
//   size: PropsTypes.number,
//   name: PropsTypes.string,
//   filename: PropsTypes.string,
//   lastModified: PropsTypes.number,
//   lastModifiedDate: PropsTypes.any,
//   url: PropsTypes.string,
//   status: UploadFileStatus,
//   percent: PropsTypes.number,
//   thumbUrl: PropsTypes.string,
//   originFileObj: PropsTypes.any,
//   response: PropsTypes.any,
//   error: PropsTypes.any,
//   linkProps: PropsTypes.any,
//   type: PropsTypes.string,
// }).loose

function UploadFile(_ref) {
  var uid = _ref.uid,
      name = _ref.name;
  if (!uid && uid !== 0) return false;
  if (!['string', 'number'].includes(_typeof(uid))) return false;
  if (name === '' || typeof name !== 'string') return false;
  return true;
}

var UploadChangeParam = {
  file: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].custom(UploadFile),
  fileList: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].arrayOf(utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].custom(UploadFile)),
  event: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].object
};
var ShowUploadListInterface = utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].shape({
  showRemoveIcon: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool,
  showPreviewIcon: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool
}).loose;
var UploadLocale = utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].shape({
  uploading: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string,
  removeFile: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string,
  downloadFile: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string,
  uploadError: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string,
  previewFile: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string
}).loose;
var UploadProps = {
  type: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOf(['drag', 'select']),
  name: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string,
  defaultFileList: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].arrayOf(utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].custom(UploadFile)),
  fileList: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].arrayOf(utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].custom(UploadFile)),
  action: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOfType([utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string, utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].func]),
  directory: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool,
  data: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOfType([utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].object, utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].func]),
  method: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOf(['POST', 'PUT', 'post', 'put']),
  headers: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].object,
  showUploadList: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOfType([utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool, ShowUploadListInterface]),
  fileMaxLength: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].number,
  multiple: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool,
  accept: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string,
  beforeUpload: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].func,
  // onChange: PropsTypes.func,
  listType: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOf(['text', 'picture', 'picture-card']),
  btnTxt: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string,
  // className: PropsTypes.string,
  // onPreview: PropsTypes.func,
  remove: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].func,
  supportServerRender: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool,
  // style: PropsTypes.object,
  disabled: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool,
  prefixCls: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string,
  customRequest: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].func,
  withCredentials: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool,
  openFileDialogOnClick: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool,
  locale: UploadLocale,
  height: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].number,
  id: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string,
  previewFile: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].func,
  transformFile: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].func,
  imageValue: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string
};
var UploadState = {
  fileList: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].arrayOf(utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].custom(UploadFile)),
  dragState: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string
};
var UploadListProps = {
  listType: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOf(['text', 'picture', 'picture-card']),
  // onPreview: PropsTypes.func,
  // onRemove: PropsTypes.func,
  // items: PropsTypes.arrayOf(UploadFile),
  items: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].arrayOf(utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].custom(UploadFile)),
  // items: PropsTypes.any,
  progressAttr: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].object,
  prefixCls: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string,
  showRemoveIcon: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool,
  showDownloadIcon: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool,
  showPreviewIcon: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].bool,
  locale: UploadLocale,
  previewFile: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].func
};

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var babel_helper_vue_jsx_merge_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var babel_helper_vue_jsx_merge_props__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_uniqBy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(213);
/* harmony import */ var lodash_uniqBy__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_uniqBy__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_findIndex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(133);
/* harmony import */ var lodash_findIndex__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_findIndex__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_pick__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(214);
/* harmony import */ var lodash_pick__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_pick__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var base_vc_upload__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(164);
/* harmony import */ var utils_BaseMixin__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4);
/* harmony import */ var utils_props_util__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1);
/* harmony import */ var base_locale_provider_LocaleReceiver__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15);
/* harmony import */ var base_locale_provider_default__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43);
/* harmony import */ var base_config_provider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8);
/* harmony import */ var _dragger__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(73);
/* harmony import */ var _uploadList__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(216);
/* harmony import */ var _interface__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(33);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(28);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MegUpload',
  mixins: [utils_BaseMixin__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"]],
  inheritAttrs: false,
  Dragger: _dragger__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"],
  props: Object(utils_props_util__WEBPACK_IMPORTED_MODULE_7__["initDefaultProps"])(_interface__WEBPACK_IMPORTED_MODULE_13__[/* UploadProps */ "c"], {
    type: 'select',
    multiple: false,
    action: '',
    data: {},
    accept: '',
    beforeUpload: _utils__WEBPACK_IMPORTED_MODULE_14__[/* T */ "b"],
    showUploadList: true,
    fileMaxLength: 0,
    // 文件列表最大长度
    listType: 'text',
    // or pictrue
    btnTxt: '上传文件',
    // 上传文件按钮文案
    disabled: false,
    supportServerRender: true,
    imageValue: ''
  }),
  inject: {
    configProvider: {
      default: function _default() {
        return base_config_provider__WEBPACK_IMPORTED_MODULE_10__["ConfigConsumerProps"];
      }
    }
  },
  // recentUploadStatus: boolean | PromiseLike<any>;
  data: function data() {
    this.progressTimer = null;
    return {
      sFileList: this.fileList || this.defaultFileList || [],
      dragState: 'drop'
    };
  },
  watch: {
    fileList: function fileList(val) {
      this.sFileList = val || [];
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clearProgressTimer();
  },
  methods: {
    onStart: function onStart(file) {
      var targetItem = Object(_utils__WEBPACK_IMPORTED_MODULE_14__[/* fileToObject */ "c"])(file);
      targetItem.status = 'uploading';
      var nextFileList = this.sFileList.concat();
      var fileIndex = lodash_findIndex__WEBPACK_IMPORTED_MODULE_3___default()(nextFileList, function (_ref) {
        var uid = _ref.uid;
        return uid === targetItem.uid;
      });

      if (fileIndex === -1) {
        nextFileList.push(targetItem);
      } else {
        nextFileList[fileIndex] = targetItem;
      }

      this.onChange({
        file: targetItem,
        fileList: nextFileList
      }); // fix ie progress

      if (!window.File || process.env.TEST_IE) {
        this.autoUpdateProgress(0, targetItem);
      }
    },
    onSuccess: function onSuccess(response, file, xhr) {
      this.clearProgressTimer();

      try {
        if (typeof response === 'string') {
          response = JSON.parse(response);
        }
      } catch (e) {
        /* do nothing */
      }

      var fileList = this.sFileList;
      var targetItem = Object(_utils__WEBPACK_IMPORTED_MODULE_14__[/* getFileItem */ "e"])(file, fileList); // removed

      if (!targetItem) {
        return;
      }

      targetItem.status = 'done';
      targetItem.response = response;
      targetItem.xhr = xhr;
      this.onChange({
        file: _objectSpread({}, targetItem),
        fileList: fileList
      });
    },
    onProgress: function onProgress(e, file) {
      var fileList = this.sFileList;
      var targetItem = Object(_utils__WEBPACK_IMPORTED_MODULE_14__[/* getFileItem */ "e"])(file, fileList); // removed

      if (!targetItem) {
        return;
      }

      targetItem.percent = e.percent;
      this.onChange({
        event: e,
        file: _objectSpread({}, targetItem),
        fileList: this.sFileList
      });
    },
    onError: function onError(error, response, file) {
      this.clearProgressTimer();
      var fileList = this.sFileList;
      var targetItem = Object(_utils__WEBPACK_IMPORTED_MODULE_14__[/* getFileItem */ "e"])(file, fileList); // removed

      if (!targetItem) {
        return;
      }

      targetItem.error = error;
      targetItem.response = response;
      targetItem.status = 'error';
      this.onChange({
        file: _objectSpread({}, targetItem),
        fileList: fileList
      });
    },
    onReject: function onReject(fileList) {
      this.$emit('reject', fileList);
    },
    handleRemove: function handleRemove(file) {
      var _this = this;

      var onRemove = this.remove;
      var fileList = this.$data.sFileList;
      Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(function (ret) {
        // Prevent removing file
        if (ret === false) {
          return;
        }

        var removedFileList = Object(_utils__WEBPACK_IMPORTED_MODULE_14__[/* removeFileItem */ "i"])(file, fileList);

        if (removedFileList) {
          file.status = 'removed'; // eslint-disable-line

          if (_this.upload) {
            _this.upload.abort(file);
          }

          _this.onChange({
            file: file,
            fileList: removedFileList
          });
        }
      });
    },
    handleManualRemove: function handleManualRemove(file) {
      if (this.$refs.uploadRef) {
        this.$refs.uploadRef.abort(file);
      }

      this.handleRemove(file);
    },
    onChange: function onChange(info) {
      if (!Object(utils_props_util__WEBPACK_IMPORTED_MODULE_7__["hasProp"])(this, 'fileList')) {
        this.setState({
          sFileList: info.fileList
        });
      }

      this.$emit('change', info);
    },
    onFileDrop: function onFileDrop(e) {
      this.setState({
        dragState: e.type
      });
    },
    reBeforeUpload: function reBeforeUpload(file, fileList) {
      var beforeUpload = this.$props.beforeUpload;
      var stateFileList = this.$data.sFileList;

      if (!beforeUpload) {
        return true;
      }

      var result = beforeUpload(file, fileList);

      if (result === false) {
        this.onChange({
          file: file,
          fileList: lodash_uniqBy__WEBPACK_IMPORTED_MODULE_2___default()(stateFileList.concat(fileList.map(_utils__WEBPACK_IMPORTED_MODULE_14__[/* fileToObject */ "c"])), function (item) {
            return item.uid;
          })
        });
        return false;
      }

      if (result && result.then) {
        return result;
      }

      return true;
    },
    clearProgressTimer: function clearProgressTimer() {
      clearInterval(this.progressTimer);
    },
    autoUpdateProgress: function autoUpdateProgress(_, file) {
      var _this2 = this;

      var getPercent = Object(_utils__WEBPACK_IMPORTED_MODULE_14__[/* genPercentAdd */ "d"])();
      var curPercent = 0;
      this.clearProgressTimer();
      this.progressTimer = setInterval(function () {
        curPercent = getPercent(curPercent);

        _this2.onProgress({
          percent: curPercent * 100
        }, file);
      }, 200);
    },
    renderUploadList: function renderUploadList(locale) {
      var h = this.$createElement;

      //渲染返回上传列表
      var _getOptionProps = Object(utils_props_util__WEBPACK_IMPORTED_MODULE_7__["getOptionProps"])(this),
          _getOptionProps$showU = _getOptionProps.showUploadList,
          showUploadList = _getOptionProps$showU === void 0 ? {} : _getOptionProps$showU,
          listType = _getOptionProps.listType,
          previewFile = _getOptionProps.previewFile,
          disabled = _getOptionProps.disabled,
          propLocale = _getOptionProps.locale;

      var showRemoveIcon = showUploadList.showRemoveIcon,
          showPreviewIcon = showUploadList.showPreviewIcon,
          showDownloadIcon = showUploadList.showDownloadIcon;
      var fileList = this.$data.sFileList;
      var uploadListProps = {
        props: {
          listType: listType,
          items: fileList,
          previewFile: previewFile,
          showRemoveIcon: !disabled && showRemoveIcon,
          showPreviewIcon: showPreviewIcon,
          showDownloadIcon: showDownloadIcon,
          locale: _objectSpread(_objectSpread({}, locale), propLocale)
        },
        on: _objectSpread({
          remove: this.handleManualRemove
        }, lodash_pick__WEBPACK_IMPORTED_MODULE_4___default()(Object(utils_props_util__WEBPACK_IMPORTED_MODULE_7__["getListeners"])(this), ['download', 'preview']))
      };
      return h(_uploadList__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"], uploadListProps);
    },
    renderUploadBtnContent: function renderUploadBtnContent(prefixCls, locale) {
      var h = this.$createElement;

      var _getOptionProps2 = Object(utils_props_util__WEBPACK_IMPORTED_MODULE_7__["getOptionProps"])(this),
          disabled = _getOptionProps2.disabled;

      if (this.listType === 'picture-card') {
        var _classNames;

        return h("div", {
          "class": classnames__WEBPACK_IMPORTED_MODULE_1___default()(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-picture-card-btn"), true), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames))
        }, [h("div", {
          "class": "".concat(prefixCls, "-icon")
        }, [h("meg-icon", {
          attrs: {
            name: "megui-add",
            width: '32',
            height: '32'
          },
          "class": "".concat(prefixCls, "-icon")
        })]), h("div", {
          "class": "".concat(prefixCls, "-text")
        }, [locale.uploadText])]);
      }

      return h("meg-button", {
        attrs: {
          type: "primary",
          icon: "megui-add",
          disabled: disabled
        }
      }, [locale.btnTxt]);
    },
    renderUpload: function renderUpload(locale) {
      var _classNames3,
          _this3 = this;

      var h = this.$createElement;

      var _getOptionProps3 = Object(utils_props_util__WEBPACK_IMPORTED_MODULE_7__["getOptionProps"])(this),
          customizePrefixCls = _getOptionProps3.prefixCls,
          showUploadList = _getOptionProps3.showUploadList,
          fileMaxLength = _getOptionProps3.fileMaxLength,
          listType = _getOptionProps3.listType,
          type = _getOptionProps3.type,
          disabled = _getOptionProps3.disabled,
          imageValue = _getOptionProps3.imageValue;

      var _this$$data = this.$data,
          fileList = _this$$data.sFileList,
          dragState = _this$$data.dragState;
      var getPrefixCls = this.configProvider.getPrefixCls;
      var prefixCls = getPrefixCls('upload', customizePrefixCls);
      var vcUploadProps = {
        props: _objectSpread(_objectSpread({}, this.$props), {}, {
          prefixCls: prefixCls,
          beforeUpload: this.reBeforeUpload
        }),
        on: {
          start: this.onStart,
          error: this.onError,
          progress: this.onProgress,
          success: this.onSuccess,
          reject: this.onReject
        },
        ref: 'uploadRef',
        attrs: _objectSpread({}, this.$attrs)
      };
      var children = this.$slots.default; // Remove id to avoid open by label when trigger is hidden
      // https://github.com/ant-design/ant-design/issues/14298

      if (!children || disabled) {
        delete vcUploadProps.props.id;
        delete vcUploadProps.attrs.id;
      }

      var uploadList = showUploadList ? this.renderUploadList() : null;

      if (type === 'drag') {
        var _classNames2;

        // 拖拽
        var dragCls = classnames__WEBPACK_IMPORTED_MODULE_1___default()(prefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-drag"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-drag-uploading"), fileList.some(function (file) {
          return file.status === 'uploading';
        })), _defineProperty(_classNames2, "".concat(prefixCls, "-drag-hover"), dragState === 'dragover'), _defineProperty(_classNames2, "".concat(prefixCls, "-disabled"), disabled), _classNames2));
        return h("span", [h("div", {
          "class": dragCls,
          on: {
            "drop": this.onFileDrop,
            "dragover": this.onFileDrop,
            "dragleave": this.onFileDrop
          }
        }, [h(base_vc_upload__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"], babel_helper_vue_jsx_merge_props__WEBPACK_IMPORTED_MODULE_0___default()([vcUploadProps, {
          "class": "".concat(prefixCls, "-btn")
        }]), [h("div", {
          "class": "".concat(prefixCls, "-drag-container")
        }, [children])])]), uploadList]);
      }

      var uploadButtonCls = classnames__WEBPACK_IMPORTED_MODULE_1___default()(prefixCls, (_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-select"), true), _defineProperty(_classNames3, "".concat(prefixCls, "-select-").concat(listType), true), _defineProperty(_classNames3, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames3, "".concat(prefixCls, "-singal"), !showUploadList), _defineProperty(_classNames3, 'done', imageValue), _classNames3));
      var uploadButton = h("div", {
        "class": uploadButtonCls,
        style: children ? undefined : listType === 'picture-card' && (!fileMaxLength || fileList.length === fileMaxLength) ? {
          display: 'none'
        } : undefined
      }, [h(base_vc_upload__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"], vcUploadProps, [children ? children : this.renderUploadBtnContent(prefixCls, locale) // 默认按钮
      , !showUploadList && h("span", {
        "class": "".concat(prefixCls, "-singal-actions"),
        on: {
          "click": function click(e) {
            return e.stopPropagation();
          }
        }
      }, [h("meg-icon", {
        attrs: {
          original: true,
          name: "megui-fill-close-circle",
          color: '#fff'
        },
        "class": "".concat(prefixCls, "-singal-actions-close"),
        on: {
          "click": function click(e) {
            e.stopPropagation();

            _this3.$emit('remove');
          }
        }
      })])])]);

      if (listType === 'picture-card') {
        return h("span", {
          "class": "".concat(prefixCls, "-picture-card-wrapper")
        }, [uploadList, uploadButton]);
      }

      return h("span", [uploadButton, uploadList]);
    }
  },
  render: function render() {
    var h = arguments[0];
    return h(base_locale_provider_LocaleReceiver__WEBPACK_IMPORTED_MODULE_8__[/* default */ "a"], {
      attrs: {
        componentName: "Upload"
      },
      scopedSlots: {
        default: this.renderUpload
      }
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(124)))

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var utils_props_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _upload__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51);
/* harmony import */ var _interface__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33);
/* harmony import */ var base_locale_provider_LocaleReceiver__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MegUploadDragger',
  props: _interface__WEBPACK_IMPORTED_MODULE_2__[/* UploadProps */ "c"],
  methods: {
    renderDragger: function renderDragger(locale) {
      var h = this.$createElement;
      var props = Object(utils_props_util__WEBPACK_IMPORTED_MODULE_0__["getOptionProps"])(this);
      var slots = this.$slots.default; // 默认slot

      var renderDefaultSlot = function renderDefaultSlot() {
        return h("div", [h("p", {
          "class": "meg-upload-drag-icon"
        }, [h("meg-icon", {
          attrs: {
            name: "cloud-upload",
            original: true,
            width: "60px",
            height: "45px"
          }
        })]), h("p", {
          "class": "meg-upload-drag-text"
        }, [locale.dragger.tips1, h("span", {
          "class": "click-upload"
        }, [locale.uploadText])])]);
      };

      var draggerProps = {
        props: _objectSpread(_objectSpread({}, props), {}, {
          type: 'drag'
        }),
        on: Object(utils_props_util__WEBPACK_IMPORTED_MODULE_0__["getListeners"])(this),
        style: {
          height: this.height
        }
      };
      return h(_upload__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"], draggerProps, [slots || renderDefaultSlot()]);
    }
  },
  render: function render() {
    var h = arguments[0];
    return h(base_locale_provider_LocaleReceiver__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
      attrs: {
        componentName: "Upload"
      },
      scopedSlots: {
        default: this.renderDragger
      }
    });
  }
});

/***/ })

}]);